export default [
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `If you don't want to tell me, I totally understand it.`,
        speakerTxtRS: `Ako ne želiš da mi kažeš, to potpuno razumijem.`,
        dialogFx: `assets/dialog/joseph/joseph0085.mp3`,
        choicesBtns: `unset`,
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `...`,
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `...`,
    }
]